import { CarouselItem } from '@/components/ui/carousel'
import { useTranslation } from 'react-i18next'

export default function DoneScreen() {
  const { t } = useTranslation()

  return (
    <CarouselItem className='px-2 sm:px-8'>
      <div className='space-y-3 py-2 text-center sm:space-y-6 sm:py-6'>
        <div className='space-y-2 sm:space-y-4'>
          <div className='mx-auto flex h-10 w-10 items-center justify-center rounded-full bg-green-100 sm:h-16 sm:w-16'>
            <svg
              aria-hidden='true'
              className='h-5 w-5 text-green-600 sm:h-8 sm:w-8'
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
            >
              <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M5 13l4 4L19 7' />
            </svg>
          </div>
          <h3 className='text-lg font-semibold text-gray-900 sm:text-2xl'>{t('needsAnalysis.done.title')}</h3>
          <p className='mx-auto max-w-xl text-sm text-gray-600 sm:text-lg'>{t('needsAnalysis.done.description')}</p>
        </div>
      </div>
    </CarouselItem>
  )
}
